import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/home-main.svg";
import singleSheet from "../../Assets/single-sheet.png";
import oceanPlastic from "../../Assets/ocean-plastic.png";
import logoRing from "../../Assets/ring.png";
import logoLeaf from "../../Assets/leaf.png";
import Tilt from "react-parallax-tilt";
import SocialMedia from "../SocialMedia/SocialMedia";
import HomeWhy from "../WhyKlean/WhyKlean";
import HomeCompact from "../CompactDesign/CompactDesign";
import BuiltForYou from "../BuiltForYou/BuiltForYou";
import TextCarousel from "../TextCarousel/TextCarousel";
import RefillBanner from "../RefillBanner/RefillBanner";

function HomeContent() {

  return (
    <>
      <Container fluid className="home-about-section primary-bg left">
        <Container className="inner-container">
          <Row>
            <Col md={4}>
                <Tilt>
                  <img src={myImg} className="img-fluid" alt="laundry detergent strips manufacturer" />
                </Tilt>
            </Col>
            <Col md={4} className="numbered-items-column white">
              <div className="numbered-item">
                <div className="circle primary">01</div>
                <h4>Low MOQs</h4>
              </div>
              <div className="numbered-item">
                <div className="circle primary">02</div>
                <h4>Fast Fulfillment</h4>
              </div>
              <div className="numbered-item">
                <div className="circle primary">03</div>
                <h4>Free Custom Design</h4>

              </div>
            </Col>

            <Col md={4} className="sample-sheet">
              <Tilt>
                <img src={singleSheet} className="img-fluid" alt="laundry detergent strips manufacturer" />
              </Tilt>
            </Col>
          </Row>
        </Container>
      </Container>

      <Container fluid className="home-about-section" >
        <Container className="inner-container left primary">
          <h2 className="home-about-title left">Tailored Laundry Solutions for Your Brand</h2>
          <Row className="home-about-content">
    
            <Col md={8} className="left home-about-feature mt-4">
             <div>We Offer:</div>
             <ul>
              <li>Private labeling</li>
              <li>Bulk manufacturing</li>
              <li>Custom scent + formula development</li>
              <li>Eco-packaging customization</li>
             </ul>
             <strong>🟢 Based in the U.S. | Built for Your Market</strong>
            </Col>
            <Col md={4}>
            <div className="rotate-logo-wrapper">
              <img src={logoLeaf} className="img-fluid leaf" alt="laundry detergent strips manufacturer" />
              <img src={logoRing} className="img-fluid ring" alt="laundry detergent strips manufacturer" />
            </div>
            </Col>
          </Row>
          <a href="/contact" className="primary-btn mt-3">Contact Now</a>
        </Container>
      </Container>

      <HomeWhy />
      <HomeCompact />
      <BuiltForYou />
      <RefillBanner />
      <TextCarousel />

      <Container fluid className="home-about-section primary left  mt-5">
        <Container>
          <h2>
            Our Responsibility:
          </h2>
          <img src={oceanPlastic} className="img-fluid plastic-ocean" alt="laundry detergent strips manufacturer" />
          <p className="mt-5">
          Every year, over 700 million plastic jugs end up in landfills and oceans. At Klean Leaf, we’re on a mission to change that. We provide a powerful laundry solution that dissolves completely—no plastic waste, no harmful residue—so your brand can deliver a cleaner planet for future generations.
          </p>

          <Row>
            <Col md={12} className="home-about-social center primary">
              <h2>FIND US ON</h2>
              <p>Feel free to connect with us</p>
              <SocialMedia />
              <a
                href="mailto:hello@kleanleaf.us"
                style={{ textDecoration: "none", color: "#134b4e" }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <p>hello@kleanleaf.us</p>
              </a>
              <a
                href="mailto:kleanleaf@gmail.coms"
                style={{ textDecoration: "none", color: "#134b4e" }}
                target="_blank"
                rel="noopener noreferrer"
              >
                <p>kleanleaf@gmail.com</p>
              </a>
              <a
                href="tel:614-906-5129"
                style={{ textDecoration: "none", color: "#134b4e" }}
              >
                <p>614.906.5129</p>
              </a>
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  );
}
export default HomeContent;
